<template>
  <div>
    <no-ssr>
      <div class="VipRenewalNotice" v-if="isLogin">
        <!--  大浮标  v-show="VIP_RENEWAL_STATE.BIG === state" -->
        <div class="buoy-big"
             :class="VIP_RENEWAL_STATE.BIG === state ? 'ON' : 'NO' "
             @click="toPay">
          <div class="headline">您的VIP会员即将到期</div>
          <div class="subhead">到期后将失去以下权益</div>
          <div class="equity-list">
            <span class="equity-item">下载次数</span>
            <span class="equity-item">商用授权</span>
            <span class="equity-item">版权保障</span>
          </div>
          <div class="renewal-btn">立即续费</div>
          <i class="iconfont icon-cha" @click.stop="closeBuoyBig"/>
        </div>

        <!--  小浮标 v-if="VIP_RENEWAL_STATE.SMALL === state " -->
        <div class="buoy-small"
             :class=" VIP_RENEWAL_STATE.SMALL === state ? 'ON' : 'NO' "
             @click="toPay">
          <div class="headline">别让版权保障过期哦~</div>
          <div class="renewal-btn">立即续费</div>
          <i class="iconfont icon-cha" @click.stop="state = -1"/>
        </div>
      </div>
    </no-ssr>
  </div>
</template>

<script>
import {VIP_STATE} from "@/constant/VIP";
import {PAY_BUSINESS, PAY_COMPANY} from "@/constant/PATH";
import {mapState} from "vuex";
import {MODEL_NEW_USER_GIFT, MODEL_VIP_RENEWAL} from "@/constant/MODELS";
import {tag} from "@/utils/statUtil";
import localStorage from "@/utils/localStorage";
import {fnUser} from "@/fn";

const VIP_RENEWAL_STATE = {
  BIG: 'big',
  SMALL: 'small',
  DEFAULT: 'big',
}

import {PAY_PERSON} from "@/constant/_Public/Path"

export default {
  name: "VipRenewalNotice",
  data() {
    return {
      VIP_RENEWAL_STATE,
      state: -1,
      vipExpireInfo: []
    }
  },
  watch: {
    isLogin(n, o) {
      if (n == true) {
        this.init();
      }
    }
  },
  computed: {
    ...mapState('user',
      [
        'personVipState',
        'personVipInfo',
        'businessVipState',
        'businessVipInfo',
        'companyVipState',
        'companyVipInfo',
        'isLogin'
      ]
    ),
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      setTimeout(() => {
        this.getVipRenewalState();
      }, 1000)
    },

    getVipRenewalState() {
      let vipExpireInfo = this.getVipExpireState();
      this.vipExpireInfo = vipExpireInfo;
      if (vipExpireInfo.length) {
        if (!this.getState() || this.getState() === VIP_RENEWAL_STATE.BIG) {
          this.state = VIP_RENEWAL_STATE.BIG;
          this.updateState(VIP_RENEWAL_STATE.BIG);
        } else {
          this.state = this.getState();
          this.updateState(this.getState());
        }
      } else {
        this.state = -1
        /* this.state = -1
         this.updateState(-1);*/
      }
    },


    vipNoticeTip(remaining_days, vipType, url, id) {
      let dataArr = [7, 3, 2, 1],
        noticeData = [];

      /*dataArr.forEach((vo, idx) => {

      })*/

      if (remaining_days <= 7 && remaining_days > -1) {
        noticeData.push({
          vipType: vipType,
          url: url,
          endDay: remaining_days,
          id
        })
      }

      return noticeData;
    },

    getVipExpireState() {
      let noticeData = [];
      /* 检查过期会员 */
      if (this.personVipState === VIP_STATE.ON) {
        let remaining_days = this.personVipInfo.remaining_days;
        let data = this.vipNoticeTip(remaining_days, '普通VIP', PAY_PERSON, 1);
        noticeData = noticeData.concat(data)
      }

    /*  if (this.businessVipState === VIP_STATE.ON) {
        let remaining_days = this.businessVipInfo.remaining_days;
        let data = this.vipNoticeTip(remaining_days, '商用VIP', PAY_BUSINESS, 2);
        noticeData = noticeData.concat(data)
      }*/

      if (this.companyVipState === VIP_STATE.ON) {
        let remaining_days = this.companyVipInfo.remaining_days;
        let data = this.vipNoticeTip(remaining_days, '企业VIP', PAY_COMPANY, 3);
        noticeData = noticeData.concat(data)
      }

      // return noticeData
      let a = noticeData.sort((a, b) => { return b-a})
      return a
    },


    sortArr(array){
      return array.sort((a, b) => { return b-a})[0].id
    },


    toPay() {
      if (this.getVipExpireState().length) {
        // 按照最高vip续费
        tag('充值:续费到期弹窗:图片')
        let routeUrl = this.vipExpireInfo[0].url
        window.open(routeUrl, '_blank');
      }
    },

    closeBuoyBig() {
      this.state = VIP_RENEWAL_STATE.SMALL
      this.updateState(VIP_RENEWAL_STATE.SMALL)
    },

    getState() {
      return this.$localStorage.getItemDate(MODEL_VIP_RENEWAL);

    },
    updateState(value = 1) {
      this.$localStorage.setItemDate(MODEL_VIP_RENEWAL, value);
    },

  }
}
</script>

<style lang="scss" scoped>
.VipRenewalNotice {

  .buoy-big {
    position: fixed;
    bottom: 120px;
    //left: 0;
    @include BgImage(330px, 163px, 'notice/vip-renewal/buoybg%40big.png');
    z-index: 21;
    transition: all 0.8s ease-in-out;

    &.NO {
      left: -500px;
    }

    &.ON {
      left: 0;
    }

    .icon-cha {
      @include Position(1, 2, 0, 18px);
      width: 28px;
      height: 20px;
      background: #3A4065;
      border-radius: 17px 0px 0px 17px;
      color: #FFFFFF;
      font-size: 12px;
      display: flex;
      align-items: center;
      padding-left: 10px;
      box-sizing: border-box;
      cursor: pointer;
      @include ElementHover(#8B91B3, #ECEFF6);
    }

    .headline {
      font-size: 18px;
      font-weight: bold;
      color: #F6CF97;
      line-height: 24px;
      letter-spacing: 1px;
      margin-bottom: 4px;
      margin-top: 25px;
      text-align: center;

    }

    .subhead {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.75);
      margin-bottom: 26px;
      text-align: center;
    }

    .equity-list {
      padding-left: 55px;
      font-size: 0;

      .equity-item {
        font-size: 13px;
        color: #F2D7B4;
        line-height: 17px;
        margin-right: 50px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .renewal-btn {
      width: 268px;
      height: 42px;
      background: linear-gradient(51deg, #FFE6B1 0%, #F9DA97 100%);
      border-radius: 21px;
      @include Position(1, 4, 50%, -21px);
      transform: translateX(-50%);
      font-size: 14px;
      font-weight: bold;
      color: #905226;
      line-height: 42px;
      text-align: center;
      @include ElementHover('', linear-gradient(51deg, #F9DA97 0%, #FFE6B1 100%))
    }

  }

  .buoy-small {
    position: fixed;
    bottom: 120px;
    left: 24px;
    @include BgImage(136px, 68px, 'notice/vip-renewal/buoybg@small.png');
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 20;
    transition: all 0.6s ease-in-out;

    &.NO {
      left: -500px;
    }

    &.ON {
      left: 24px;
    }

    .headline {
      font-size: 12px;
      font-weight: bold;
      color: #F6CF97;
      line-height: 16px;
      margin: 11px 0 7px;
    }

    .renewal-btn {
      width: 96px;
      background: linear-gradient(51deg, #FFE6B1 0%, #F9DA97 100%);
      border-radius: 13px;
      font-size: 12px;
      font-weight: bold;
      color: #905226;
      line-height: 24px;
      text-align: center;
      @include ElementHover('', linear-gradient(51deg, #F9DA97 0%, #FFE6B1 100%))
    }

    .icon-cha {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      line-height: 20px;
      font-size: 13px;
      color: #FFFFFF;
      text-align: center;
      background: rgba(58, 64, 101, 0.7);
      @include Position(1, 4, 50%, -28px);
      transform: translateX(-50%);
      cursor: pointer;
      @include ElementHover('', rgba(58, 64, 101, 0.5))
    }
  }

}
</style>
